import { chakra, ColorProps, Flex, keyframes } from '@chakra-ui/react'
import React from 'react'
export interface LoadingBarsProps {
  bars?: number
  color?: ColorProps['color']
  flexGrow?: boolean
  height?: string
  loading?: boolean
  margin?: string
  radius?: string
  size?: number
  width?: string
}

const loadingAnimation = keyframes`
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1.1);
    opacity: 0.7;
  }
`

const animationDuration = 500

export const LoadingBars: React.FC<LoadingBarsProps> = ({
  bars = 5,
  color = 'deepPurple',
  flexGrow,
  height,
  loading = true,
  margin,
  radius = '3px',
  size = 60,
  width,
}) => (
  <>
    {loading && (
      <Flex
        alignItems="center"
        flex={flexGrow ? '1' : undefined}
        height={!flexGrow ? height : undefined}
        justifyContent="center"
        margin={margin}
        width={!flexGrow ? width : undefined}
      >
        <Flex
          alignItems="center"
          height={height || `${(size * 0.7 * 3) / bars}px`}
          justifyContent="space-between"
          width={width || `${size}px`}
        >
          {Array(bars)
            .fill(0)
            .map((_, i) => (
              <chakra.span
                key={i}
                background={color}
                borderRadius={radius}
                height={(i + 1) % 2 ? '70%' : '100%'}
                opacity={0}
                sx={{
                  animation: `${loadingAnimation} ${animationDuration}ms ease-in-out infinite`,
                  animationDelay: `${animationDuration * (0.3 * (i + 1))}ms`,
                  animationDirection: 'alternate',
                  animationFillMode: 'forwards',
                }}
                transition="all 0.2s ease-in-out"
                width={`${100 / (bars + 1)}%`}
              />
            ))}
        </Flex>
      </Flex>
    )}
  </>
)
